import React from "react";
import "./InfoCard.scss";

const Card = ({ image, title, number }) => {
  return (
    <div className="infoCard">
      <div>
        <img src={image}></img>
        <div className="infoCard-title">{title}</div>
        <div className="infoCard-number">{number}</div>
      </div>
    </div>
  );
};

export default Card;
